"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _reactSelect = _interopRequireDefault(require("react-select"));

var _styled = require("../../../utils/styled");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  styles: (0, _propTypes.shape)({}),
  size: (0, _propTypes.oneOf)(['sm', 'md', 'lg'])
};
var defaultProps = {
  styles: undefined,
  size: 'md'
};
var FormSelect = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var classes = _ref.styles,
      size = _ref.size,
      props = _objectWithoutProperties(_ref, ["styles", "size"]);

  var theme = (0, _styled.useTheme)();
  var styles = (0, _react.useMemo)(function () {
    return _objectSpread({
      container: function container(provided) {
        return _objectSpread(_objectSpread({}, provided), {}, {
          fontFamily: theme.fonts.body,
          fontWeight: theme.fontWeights.normal,
          lineHeight: theme.lineHeights.base
        });
      },
      control: function control(provided, state) {
        return _objectSpread(_objectSpread({}, provided), {}, {
          borderColor: theme.colors.gray[400],
          borderRadius: theme.radii.md,
          backgroundColor: state.isDisabled ? theme.colors.gray[100] : theme.colors.white,
          minHeight: {
            sm: theme.sizes[8],
            md: theme.sizes[10],
            lg: theme.sizes[12]
          }[size]
        });
      },
      singleValue: function singleValue(provided) {
        return _objectSpread(_objectSpread({}, provided), {}, {
          color: theme.colors.text
        });
      },
      multiValueLabel: function multiValueLabel(provided) {
        return _objectSpread(_objectSpread({}, provided), {}, {
          color: theme.colors.text
        });
      },
      multiValueRemove: function multiValueRemove(provided) {
        return _objectSpread(_objectSpread({}, provided), {}, {
          ':hover': {
            backgroundColor: theme.colors.danger,
            color: 'white'
          }
        });
      },
      placeholder: function placeholder(provided) {
        return _objectSpread(_objectSpread({}, provided), {}, {
          color: theme.colors.text,
          fontStyle: 'italic',
          opacity: 0.6
        });
      },
      valueContainer: function valueContainer(provided) {
        return _objectSpread(_objectSpread({}, provided), size === 'sm' ? {
          fontSize: theme.fontSizes.sm,
          padding: "0 ".concat(theme.sizes[2])
        } : {
          fontSize: theme.fontSizes.md,
          padding: "2px ".concat(theme.sizes[4])
        });
      },
      dropdownIndicator: function dropdownIndicator(provided) {
        return _objectSpread(_objectSpread({}, provided), size === 'sm' ? {
          padding: theme.sizes[1]
        } : null);
      },
      clearIndicator: function clearIndicator(provided) {
        return _objectSpread(_objectSpread({}, provided), size === 'sm' ? {
          padding: theme.sizes[1]
        } : null);
      }
    }, classes);
  }, [theme, classes, size]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactSelect["default"], _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    styles: styles
  }));
});
FormSelect.propTypes = propTypes;
FormSelect.defaultProps = defaultProps;
var _default = FormSelect;
exports["default"] = _default;

//# sourceMappingURL=FormSelect.js.map